<template>
  <div v-if="isDevelopment">
    <slot />
  </div>
</template>

<script>
// @vuese
// Wyświetlenie zawartości tylko gdy NODE_ENV jest `development`
export default {
  data() {
    return { isDevelopment: process.env.NODE_ENV === 'development' };
  }
};
</script>
